import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "pastNews" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "news"
}
const _hoisted_3 = { id: "title" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { id: "date" }
const _hoisted_6 = {
  key: 0,
  id: "content"
}
const _hoisted_7 = {
  key: 1,
  id: "content"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { id: "date" }
const _hoisted_10 = {
  key: 0,
  id: "content"
}
const _hoisted_11 = {
  key: 1,
  id: "content"
}
const _hoisted_12 = { id: "date" }
const _hoisted_13 = {
  key: 0,
  id: "content"
}
const _hoisted_14 = {
  key: 1,
  id: "content"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { id: "date" }
const _hoisted_17 = {
  key: 0,
  id: "content"
}
const _hoisted_18 = {
  key: 1,
  id: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.newsListData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsListData.slice(0, this.displayNewsCount), (news) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: news }, [
                  (news.link && news.isBlank)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.routerPath(news.link),
                        target: "_blank"
                      }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(news.date), 1),
                          (_ctx.isEnglishPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(news.enText), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(news.jaText), 1))
                        ])
                      ], 8, _hoisted_4))
                    : (news.link)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.isExternalUrl(news.link))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: _ctx.routerPath(news.link)
                              }, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(news.date), 1),
                                  (_ctx.isEnglishPage)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(news.enText), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(news.jaText), 1))
                                ])
                              ], 8, _hoisted_8))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: _ctx.routerPath(news.link)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(news.date), 1),
                                    (_ctx.isEnglishPage)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(news.enText), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(news.jaText), 1))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                        ], 64))
                      : (_openBlock(), _createElementBlock("li", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(news.date), 1),
                          (_ctx.isEnglishPage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(news.enText), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(news.jaText), 1))
                        ]))
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}